// quizSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  createQuiz,
  getUsersList,
  getQuizzes,
  getQuizParticipants,
  getRegisteredQuizUsersList,
  getQuizParticipantsOld,
  getQuizStudents,
} from "./thunk";

const initialState = {
  quizForm: {
    title: "",
    start: "",
    registrationStart: "",
    registrationEnd: "",
    totalQuestions: "",
    questionDuration: "",
    correct: "1",
    wrong: "0",
    skipped: "0",
    subject_id: "",
    class_id: "",
    enableWrongMarks: false,
    enableSkippedMarks: false,
    registrationFeeMode: "",
    registrationCost: 1,
    topWinnersCount: 0,
    winnerPrizes: [],
    about: "",
    description: "",
    terms: "",
    prizeDescription: "",
  },
  quizType: "",
  updateQuizForm: {
    id: "",
    title: "",
    start: "",
    registrationStart: "",
    registrationEnd: "",
    totalQuestions: "",
    questionDuration: "",
    correct: "1",
    wrong: "0",
    skipped: "0",
    enableWrongMarks: false,
    enableSkippedMarks: false,
    registrationFeeMode: "",
    registrationCost: 0,
    topWinnersCount: 0,
    winnerPrizes: [],
    about_quiz: "",
    quiz_terms: "",
    updated_by: "",
    quizType: "",
    class_id: "",
    themeData: [],
    themeId: "",
    subject_id: "",
    law_selected: "",
    description: "",
    group_idd: [],
    class_ids: [],
    subjectSpecificClasses: [],
  },
  usersList: [],
  offset: "",
  // for the quiz status
  subThemes: [],
  selectedSubThemes: [],
  quizzes: [],
  selectedQuiz: null,
  showPopup: false,
  option: "",
  loading: false,
  error: null,
  // for user mgt
  option_selected: "",
  selectedQuizId: "",
  subFilterBy: "",
  filteredUsersList: [],
  liveParticipantsList: {
    data: [],
    total_count: 0,
    filtered_count: 0,
    offset: 0,
    limit: 100,
  },
  limit: "",
  practiceList: [], // for the practice quiz
};

const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    setQuizForm: (state, action) => {
      const { key, value } = action.payload;
      state.quizForm[key] = value;
    },
    // resetQuizForm: (state) => {
    //   state.quizForm = initialState.quizForm;
    // },
    resetQuizForm: (state) => {
      state.quizForm = {
        ...state.quizForm,

        title: "",
        start: "",
        registrationStart: "",
        registrationEnd: "",
        totalQuestions: "",
        questionDuration: "",
        correct: "1",
        wrong: "0",
        skipped: "0",
        subject_id: "",
        class_id: "",
        enableWrongMarks: false,
        enableSkippedMarks: false,
        registrationFeeMode: "",
        registrationCost: 1,
        topWinnersCount: 0,
        winnerPrizes: [],
        description: "",
        prizeDescription: "",
      };
    },
    updateWinnerPrize: (state, action) => {
      const { index, value } = action.payload;
      state.quizForm.winnerPrizes[index] = value;
    },

    // for the updation
    setUpdateQuizForm: (state, action) => {
      if (action.payload.key) {
        // single key update
        const { key, value } = action.payload;
        state.updateQuizForm[key] = value;
      } else {
        // multiple keys update
        Object.entries(action.payload).forEach(([key, value]) => {
          state.updateQuizForm[key] = value;
        });
      }
    },

    resetUpdateQuizForm: (state) => {
      state.quizForm = initialState.quizForm;
    },
    updateWinnerPrizeNew: (state, action) => {
      const { index, value } = action.payload;
      state.updateQuizForm.winnerPrizes[index] = value;
    },
    setState: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createQuiz.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createQuiz.fulfilled, (state) => {
        state.loading = false;
        state.quizForm = initialState.quizForm;
      })
      .addCase(createQuiz.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to create quiz";
      });
    builder
      .addCase(getUsersList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.loading = false;
        state.usersList = action.payload; // ✅ FIXED
      })
      .addCase(getUsersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch users";
      });
    builder
      .addCase(getQuizzes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuizzes.fulfilled, (state, action) => {
        state.loading = false;
        state.quizzes = action.payload; // ✅ FIXED
      })
      .addCase(getQuizzes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch users";
      });
    builder
      .addCase(getQuizParticipantsOld.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuizParticipantsOld.fulfilled, (state, action) => {
        state.loading = false;

        // 💡 Ensure quiz is selected
        if (!state.selectedQuizId) {
          state.liveParticipantsList = {
            data: [],
            total_count: 0,
            filtered_count: 0,
          };
          state.practiceList = [];
          return;
        }

        // 💡 Use SAME API for both Live (2) and Practice (3)
        if (state.option_selected === 2) {
          // LIVE QUIZ LIST → CommonTable
          state.liveParticipantsList = action.payload || {
            data: [],
            total_count: 0,
            filtered_count: 0,
            offset: 0,
            limit: 100,
          };
        }

        if (state.option_selected === 3) {
          // PRACTICE QUIZ LIST → ReusableTable
          state.practiceList = Array.isArray(action.payload)
            ? action.payload
            : [];
        }
      })

      .addCase(getQuizParticipantsOld.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch participants";
      });
    builder
      .addCase(getQuizStudents.fulfilled, (state, action) => {
        state.filteredUsersList = action.payload || {
          data: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(getQuizStudents.rejected, (state) => {
        state.filteredUsersList = { data: [], offset: 0, limit: 100 };
      });

    ///vfbgng
    builder
      .addCase(getRegisteredQuizUsersList.fulfilled, (state, action) => {
        state.registeredList = action.payload || {
          questions: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(getRegisteredQuizUsersList.rejected, (state) => {
        state.registeredList = { questions: [], offset: 0, limit: 100 };
      });
    // // builder
    // //   .addCase(getRegisteredQuizUsersList.pending, (state) => {
    // //     state.loading = true;
    // //     state.error = null;
    // //   })
    // //   .addCase(getRegisteredQuizUsersList.fulfilled, (state, action) => {
    // //     state.loading = false;

    // //     // store only if selectedQuizId is present
    // //     if (state.selectedQuizId) {
    // //       state.registeredList = action.payload;
    // //     } else {
    // //       state.registeredList = []; // or keep it as is
    // //     }
    // //   })

    //   .addCase(getRegisteredQuizUsersList.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message || "Failed to fetch participants";
    //   });
  },
});

export const {
  setQuizForm,
  resetQuizForm,
  updateWinnerPrize,
  addAllotment,
  updateAllotmentPercent,
  setState,
  updateWinnerPrizeNew,
  setUpdateQuizForm,
  resetUpdateQuizForm,
} = quizSlice.actions;

export default quizSlice.reducer;
